import { render, staticRenderFns } from "./TermsUpdate.vue?vue&type=template&id=a5d5574a&"
import script from "./TermsUpdate.vue?vue&type=script&lang=js&"
export * from "./TermsUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports